module.exports = __webpack_public_path__ + "static/media/power.18d63703.png";